import Backbone from 'backbone';

module.exports = Backbone.Model.extend({
  defaults: {},
  initialize(o) {}
});
